<template>
  <div class="w-full">
    <!-- 第一个卡片 -->
    <div class="mb-6 sm:mb-8">
      <div
        class="flex flex-col sm:flex-row bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
      >
        <!-- 左侧图片 - 更大的尺寸 -->
        <div
          class="relative w-full sm:w-[45%] lg:w-[420px] h-[220px] sm:h-[300px] flex-shrink-0 overflow-hidden"
        >
          <img
            src="https://pic.rmb.bdstatic.com/bjh/8eeccce6a5a3be4d44b7cf6a897b266a.jpeg"
            alt="Data Science"
            class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-110"
          />
        </div>

        <!-- 右侧内容 -->
        <div
          class="flex-1 p-5 sm:p-7 lg:p-8 flex flex-col justify-between min-h-[200px] sm:min-h-[300px]"
        >
          <div>
            <h2
              class="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-3"
            >
              Data Science
            </h2>
            <p class="text-sm sm:text-base text-gray-500 mb-4 sm:mb-5">
              Find the Number Secret
            </p>
            <p
              class="text-gray-600 text-sm sm:text-base leading-relaxed overflow-hidden line-clamp-4 sm:line-clamp-5"
            >
              djshfjishfjkjkfahjfchasjcfbajkvbahkbsdhkbvksbvjkwsbjkvbsjvbsjkvbsdjkbvahhkgbIHbdkBJsbdghjbSKBBbvjkasdvsdvsegvsesafasvgadvgbasdgbjnzjkbdfjkbn
              bvjkasdvsdvsegvsesafasvgadvgbasdgbjnzjkbdfjkbnjszdnjbvjkasdvsdvsegvses
            </p>
          </div>
          <div class="text-right mt-4 sm:mt-5">
            <a
              href="#"
              class="text-pink-500 hover:text-pink-600 font-medium text-sm sm:text-base inline-flex items-center gap-1 transition-all hover:gap-2"
            >
              Read More <span>→</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二个卡片 -->
    <div class="mb-6 sm:mb-8">
      <div
        class="flex flex-col sm:flex-row bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
      >
        <!-- 左侧图片 -->
        <div
          class="relative w-full sm:w-[45%] lg:w-[420px] h-[220px] sm:h-[300px] flex-shrink-0 overflow-hidden"
        >
          <img
            src="https://pic.rmb.bdstatic.com/bjh/8eeccce6a5a3be4d44b7cf6a897b266a.jpeg"
            alt="Data Science"
            class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-110"
          />
        </div>

        <!-- 右侧内容 -->
        <div
          class="flex-1 p-5 sm:p-7 lg:p-8 flex flex-col justify-between min-h-[200px] sm:min-h-[300px]"
        >
          <div>
            <h2
              class="text-2xl sm:text-3xl font-bold text-gray-800 mb-2 sm:mb-3"
            >
              Data Science
            </h2>
            <p class="text-sm sm:text-base text-gray-500 mb-4 sm:mb-5">
              Find the Number Secret
            </p>
            <p
              class="text-gray-600 text-sm sm:text-base leading-relaxed overflow-hidden line-clamp-4 sm:line-clamp-5"
            >
              djshfjishfjkjkfahjfchasjcfbajkvbahkbsdhkbvksbvjkwsbjkvbsjvbsjkvbsdjkbvahhkgbIHbdkBJsbdghjbSKBBbvjkasdvsdvsegvsesafasvgadvgbasdgbjnzjkbdfjkbn
              bvjkasdvsdvsegvsesafasvgadvgbasdgbjnzjkbdfjkbnjszdnjbvjkasdvsdvsegvses
            </p>
          </div>
          <div class="text-right mt-4 sm:mt-5">
            <a
              href="#"
              class="text-pink-500 hover:text-pink-600 font-medium text-sm sm:text-base inline-flex items-center gap-1 transition-all hover:gap-2"
            >
              Read More <span>→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostCard",
};
</script>

<style scoped>
.line-clamp-4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.line-clamp-5 {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
</style>
